import { render, staticRenderFns } from "./catDetail.vue?vue&type=template&id=e5a348e0&scoped=true&"
import script from "./catDetail.vue?vue&type=script&lang=ts&"
export * from "./catDetail.vue?vue&type=script&lang=ts&"
import style0 from "./catDetail.vue?vue&type=style&index=0&id=e5a348e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a348e0",
  null
  
)

export default component.exports